import { style } from '@vanilla-extract/css'

const label = style({
  display: 'block',
  cursor: 'pointer',
  width: '100%',
})

const checkmark = style({
  width: '18px',
  height: '18px',
  marginTop: '3px',
})

const checkbox = style({
  opacity: 0,
  WebkitAppearance: 'none',
  appearance: 'none',
  position: 'absolute',
})

const labelText = style({
  fontSize: '15px',
  fontWeight: '700',
  userSelect: 'none',
  flex: 1,
})

export const styles = {
  label,
  checkmark,
  checkbox,
  labelText,
}
